export default "__VITE_ASSET__DB65ZHdB__"